import { variables as vars, tokens } from '@domain-group/fe-brary';
export default {
  base: {
    borderWidth: vars.button.borderWidth,
    innerBorderRadius: tokens.borderRadius.inner,
    outerBorderRadius: tokens.borderRadius.outer,
    borderColour: 'transparent',
    fontWeight: vars.button.fontWeight
  },
  size: {
    mini: {
      innerBorderRadius: tokens.borderRadius.mini,
      outerBorderRadius: tokens.borderRadius.mini,
      padding: vars.button.miniPadding,
      iconOnlyPadding: '3px',
      fontSize: vars.button.miniFontSize,
      lineHeight: vars.button.miniLineHeight
    },
    small: {
      innerBorderRadius: tokens.borderRadius.inner,
      outerBorderRadius: tokens.borderRadius.outer,
      padding: vars.button.smallPadding,
      iconOnlyPadding: '2px',
      fontSize: vars.button.smallFontSize,
      lineHeight: vars.button.smallLineHeight
    },
    regular: {
      innerBorderRadius: tokens.borderRadius.inner,
      outerBorderRadius: tokens.borderRadius.outer,
      padding: vars.button.padding,
      iconOnlyPadding: '8px',
      fontSize: vars.button.fontSize,
      lineHeight: vars.button.lineHeight
    },
    large: {
      innerBorderRadius: tokens.borderRadius.inner,
      outerBorderRadius: tokens.borderRadius.outer,
      padding: vars.button.largePadding,
      iconOnlyPadding: '17px',
      fontSize: vars.button.largeFontSize,
      lineHeight: vars.button.largeLineHeight
    }
  }
};